import { Link } from './link';
import { LinkCriteriaModel } from './link-criteria.model';

export class LinkReference {
    public criteria?: LinkCriteriaModel;
    public linkWeb?: Link;
    public linkNative?: { inApp: string } | { browser: string };

    public constructor(init?: Partial<LinkReference>) {
        Object.assign(this, init);
    }
}
